$shm_hitalama_map_widget_float_code_html_bench $shm_hitalama_map_widget_float_code_bench
	Result_view $shm_hitalama_map_widget_float_code_html_bench_result
		state <= process_state
